import { RoomStatus } from "@/types/room";

export const shouldShowRoomStatusField = (isRapid: boolean): boolean =>
  !isRapid;

export const resolveAddRoomStatus = (
  isRapid: boolean,
  selected: RoomStatus | undefined,
): RoomStatus | undefined => (isRapid ? RoomStatus.AVAILABLE : selected);
